import {number} from "yup";

import { validationMessages } from "./validationMessages";

export const checkboxRequiredValidationSchema = number()
  .test(
    "requiredCheckbox",
    validationMessages.requiredField,
    function (checkboxValue) {
      return checkboxValue !== 0;
    }
  );
